<template>
	<div>
		<el-row>
			<div class="page-body">
				<div style="display: flex; justify-content: space-between">
					<div>
						<el-form :inline="true" class="demo-form-inline" label-position="right" label-width="100px"
							:model="searcheForm">
							<el-form-item label="站点名称:">
								<el-input placeholder="请输入站点名称" clearable width="200px"
									v-model="searcheForm.stationName"></el-input>
							</el-form-item>
							<el-form-item label="区域">
								<el-cascader
								    v-model="searcheForm.area"
								    :options="areaOptions"
									:props="{ checkStrictly: true }"
								    @change="handleChange" clearable></el-cascader>
							</el-form-item>
							<el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
						</el-form>
					</div>
					<div>
						<el-button type="primary" icon="el-icon-plus" @click="showAdd">新增</el-button>
					</div>
				</div>
			</div>
		</el-row>
		<el-row>
			<el-col :span="24">
				<div style="margin-top: 30px; display: block">
					<el-table :data="stationList" stripe border v-loading="loading" element-loading-text="正在加载..."
						element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
						style="width: 100%"
						@row-click="stationTableItemClick">
						<el-table-column prop="stationName" label="站点名称" fixed align="center"
							width="200" ></el-table-column>
							<el-table-column prop="linkman" label="联系人" fixed align="center"
								width="150" ></el-table-column>
								<el-table-column prop="" label="所在城市" fixed align="center"
									width="200" >
									<template slot-scope="scope">
										<el-tag v-if="scope.row.province!=null">{{scope.row.province}}</el-tag>
										&nbsp;&nbsp;
										<el-tag v-if="scope.row.city!=null">
											{{scope.row.city}}
										</el-tag>
									</template>
									</el-table-column>
								<el-table-column prop="address" label="地址" fixed align="center"
									 ></el-table-column>
						<el-table-column fixed="right" width="200" align="center" label="操作">
							<template slot-scope="scope">
									<el-button type="text"  style="display:none"  size="mini" @click="tableClickedAppendGateway(scope.row)"
										>
										添加网关
									</el-button>
									<el-button style="display:none" type="text" size="mini"
										@click="() => appendPlug(data)">
										添加插座
									</el-button>
									<el-button style="display:none" type="text" size="mini"
										@click="() => remove(node, data)">
										Delete
									</el-button>
								<!-- <el-button size="mini" @click="showEditStationView(scope.row)">编辑</el-button> -->
								<!-- <el-button @click="deleteChargeStation(scope.row)" type="danger">删除</el-button> -->
							</template>
						</el-table-column>
					</el-table>
					<div style="display: flex; justify-content: flex-end">
						<el-pagination background @current-change="currentChange" @size-change="sizeChange"
							layout="sizes, prev, pager, next, jumper, ->, total, slot" :total="total"></el-pagination>
					</div>
				</div>
				<!-- 表格 END -->
			</el-col>
		</el-row>
		<el-drawer
		  title="充电站点详情"
		  :visible.sync="drawer"
		  direction="rtl"
		  size="60%">
		 
		<el-row>
			
			<el-col :span="6" style="display: none;">
				<!-- tree -->
				<el-tree :data="treeData" node-key="treeId">
					<span class="custom-tree-node" slot-scope="{ node, data }" style="width: 100%">
						<el-row style="line-height:45px;">
							<el-col :span="15" style="line-height:40px;">
								<span :class="rootStationId == data.treeId?'tree-node-checked':''"
									@click="() => nodeClick(data)">{{ data.treeName }}</span>
							</el-col>
							<el-col :span="9">
								<span>
									<el-button type="text" size="mini" @click="() => appendGateway(data)"
										v-if="node.level == 1">
										添加网关
									</el-button>
									<el-button style="display:none" type="text" size="mini"
										@click="() => appendPlug(data)" v-if="node.level == 2">
										添加插座
									</el-button>
									<el-button style="display:none" type="text" size="mini"
										@click="() => remove(node, data)">
										Delete
									</el-button>
								</span>
							</el-col>
						</el-row>
					</span>
				</el-tree>
				<!-- tree-->
			</el-col>
			<el-col :span="1">&nbsp;</el-col>
			<el-col :span="24">
				<!-- -->
				<el-tabs type="border-card" @tab-click="tabClick" v-model="activeDetailTab">
					<el-tab-pane label="站点/小区详情" name="detailTab" aria-selected="true">
						<el-row class="detail-row">
							<el-col :span="6" class="detail-col-even">站点名称：</el-col>
							<el-col :span="18" class="detail-col-odd">&nbsp;{{ detailData.row.stationName }}
								<el-tooltip class="item" effect="dark" content="点击进入编辑" placement="top">
									<el-button type="primary" icon="el-icon-edit"
										@click="showEditStationView(detailData.row)"></el-button>
								</el-tooltip>
							</el-col>
						</el-row>
						<el-row class="detail-row">
							<el-col :span="6" class="detail-col-even">物业：</el-col>
							<el-col :span="18" class="detail-col-odd">&nbsp;{{ detailData.row.management }}
							</el-col>
						</el-row>
						<el-row class="detail-row">
							<el-col :span="6" class="detail-col-even">联系人：</el-col>
							<el-col :span="18" class="detail-col-odd">&nbsp;{{ detailData.row.linkman }}
							</el-col>
						</el-row>

						<el-row class="detail-row">
							<el-col :span="6" class="detail-col-even">联系电话：</el-col>
							<el-col :span="18" class="detail-col-odd">&nbsp;{{ detailData.row.phone }}
							</el-col>
						</el-row>
						<el-row class="detail-row">
							<el-col :span="6" class="detail-col-even">所在区域：</el-col>
							<el-col :span="18" class="detail-col-odd">&nbsp;
							{{ detailData.row.province }} / {{ detailData.row.city }} / {{ detailData.row.area }}

							</el-col>
						</el-row>
						<el-row class="detail-row">
							<el-col :span="6" class="detail-col-even">所属街道：</el-col>
							<el-col :span="18" class="detail-col-odd">&nbsp;{{ detailData.row.street }}
							</el-col>
						</el-row>
						<el-row class="detail-row">
							<el-col :span="6" class="detail-col-even">详细地址：</el-col>
							<el-col :span="18" class="detail-col-odd">&nbsp;
							
							{{ detailData.row.address }}</el-col>
						</el-row>
						<el-row class="detail-row">
							<el-col :span="5" class="detail-col-even">经度:</el-col>
							<el-col :span="7" class="detail-col-odd">&nbsp;{{ detailData.row.stationLng }}</el-col>
							<el-col :span="5" lass="detail-col-even">纬度：</el-col>
							<el-col :span="7" lass="detail-col-odd">&nbsp;{{ detailData.row.stationLat }}</el-col>
						</el-row>
						<el-row class="detail-row">
							<el-col :span="6" class="detail-col-even">备注:</el-col>
							<el-col :span="18" class="detail-col-odd">&nbsp;{{ detailData.row.remark }}</el-col>
						</el-row>
					</el-tab-pane>
					<el-tab-pane label="网关列表" name="detailGatewayTab">
						<!--Gateway -->
						<!-- 表格 start -->
						<gateway-table :rootStationId="rootStationId" ref="GatewayTable" />
						<!-- 表格 END -->
					</el-tab-pane>
					<el-tab-pane label="设备列表" name="detailEquipmentTab">
						<equipment-table ref="EquipmentTable" :rootStationId="rootStationId" />
					</el-tab-pane>
					<el-tab-pane label="计费模板" name="detailFeeTab">
						<el-row class="detail-row">
							<el-col :span="6" class="detail-col-even">模板名称：</el-col>
							<el-col :span="18"
								class="detail-col-odd">&nbsp;
								<el-tag type="success">{{ detailData.row.chargePricePrivacyInfo.name }} </el-tag>
								</el-col>
						</el-row>
						<el-row class="detail-row">
							<el-col :span="6" class="detail-col-even">模板编号：</el-col>
							<el-col :span="18"
								class="detail-col-odd">&nbsp;{{ detailData.row.chargePricePrivacyInfo.code }}</el-col>
						</el-row>

						<el-row class="detail-row">
							<el-col :span="6" class="detail-col-even">计费方式：</el-col>
							<el-col :span="18" class="detail-col-odd">&nbsp;
								<span v-if="detailData.row.chargePricePrivacyInfo.feeType == 1">
									按小时计费
								</span>
								<span v-if="detailData.row.chargePricePrivacyInfo.feeType == 2">
									按电量
								</span>
							</el-col>
						</el-row>

						<el-row class="detail-row">
							<el-col :span="6" class="detail-col-even">价格：</el-col>
							<el-col :span="18" class="detail-col-odd">&nbsp;{{
                  detailData.row.chargePricePrivacyInfo.price
                }}
								分/小时</el-col>
						</el-row>
						<el-row class="detail-row">
							<el-col :span="6" class="detail-col-even">计费时段：</el-col>
							<el-col :span="18" class="detail-col-odd">&nbsp;{{
                  detailData.row.chargePricePrivacyInfo.durationOption
                }}</el-col>
						</el-row>

						<el-row class="detail-row">
							<el-col :span="6" class="detail-col-even">备注：</el-col>
							<el-col :span="18" class="detail-col-odd">&nbsp;{{
                  detailData.row.chargePricePrivacyInfo.remark
                }}</el-col>
						</el-row>
					</el-tab-pane>
					<el-tab-pane label="月卡续费模板" name="detailCardFeeTab">
						<el-row class="detail-row">
							<el-col :span="6" class="detail-col-even">模板名称：</el-col>
							<el-col :span="18"
								class="detail-col-odd">&nbsp;
								<el-tag type="success">
								{{ detailData.row.vipCardPrivacyInfo.name }}
								</el-tag>
								</el-col>
						</el-row>
						<el-row class="detail-row">
							<el-col :span="6" class="detail-col-even">模板编号：</el-col>
							<el-col :span="18"
								class="detail-col-odd">&nbsp;{{ detailData.row.vipCardPrivacyInfo.code }}</el-col>
						</el-row>

						<el-row class="detail-row">
							<el-col :span="6" class="detail-col-even">有效时长：</el-col>
							<el-col :span="18" class="detail-col-odd">&nbsp;
								<span v-if="detailData.row.vipCardPrivacyInfo.feeType == 1">
									30天 &nbsp;
									<el-link type="warning" disabled>自购买之日起30天内有效，可累计！</el-link>
								</span>
								<span v-if="detailData.row.vipCardPrivacyInfo.feeType == 2">
									90天 &nbsp;
									<el-link type="warning" disabled>自购买之日起90天内有效，可累计！
									</el-link>
								</span>
								<span v-if="detailData.row.vipCardPrivacyInfo.feeType == 3">
									一年 &nbsp;
									<el-link type="warning" disabled>自购买之日起一年内有效，可累计！</el-link>
								</span>
							</el-col>
						</el-row>

						<el-row class="detail-row">
							<el-col :span="6" class="detail-col-even">价格：</el-col>
							<el-col :span="18" class="detail-col-odd">&nbsp;{{
                  detailData.row.vipCardPrivacyInfo.price/100
                }} 元 </el-col>
						</el-row>
						<el-row class="detail-row">
							<el-col :span="6" class="detail-col-even">日可用时长：</el-col>
							<el-col :span="18" class="detail-col-odd">&nbsp;{{
                  detailData.row.vipCardPrivacyInfo.dailyAvailableHours
                }}</el-col>
						</el-row>
						<el-row class="detail-row">
							<el-col :span="6" class="detail-col-even">累计可用时长：</el-col>
							<el-col :span="18" class="detail-col-odd">&nbsp;{{
                  detailData.row.vipCardPrivacyInfo.availableHours
                }}</el-col>
						</el-row>

						<el-row class="detail-row">
							<el-col :span="6" class="detail-col-even">备注：</el-col>
							<el-col :span="18" class="detail-col-odd">&nbsp;{{
                  detailData.row.chargePricePrivacyInfo.remark
                }}</el-col>
						</el-row>
					</el-tab-pane>
				</el-tabs>
				<!-- -->
				<!-- 表格 start -->
				<div style="margin-top: 30px; display: none">
					<el-table :data="stationList" stripe border v-loading="loading" element-loading-text="正在加载..."
						element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
						style="width: 100%">
						<el-table-column prop="stationName" label="站点名称" fixed align="center"
							width="300"></el-table-column>
						<el-table-column prop="code" label="站点编码" width="300" align="center"></el-table-column>
						<el-table-column prop="stationLng" label="经度" width="300" align="center"></el-table-column>
						<el-table-column prop="stationLat" label="纬度" width="300" align="center"></el-table-column>
						<el-table-column prop="stationTel" label="联系电话" width="200" align="center"></el-table-column>
						<el-table-column prop="serviceTel" label="服务电话" width="200" align="center"></el-table-column>
						<el-table-column prop="stationStatus" label="站点状态" width="300" align="center"></el-table-column>
						<el-table-column prop="durationOption" label="计费时段" width="300"
							align="center"></el-table-column>
						<el-table-column prop="privacyId" label="计费方式" width="300" align="center"></el-table-column>
						<el-table-column prop="address" label="详细地址" width="300" align="center"></el-table-column>
						<el-table-column prop="remark" label="备注" width="500" align="center"></el-table-column>
						<el-table-column prop="createTime" label="创建时间" width="200" align="center"></el-table-column>
						<el-table-column prop="updateTime" label="更新时间" width="200" align="center"></el-table-column>
						<el-table-column fixed="right" width="200" align="center" label="操作">
							<template slot-scope="scope">
								<el-button @click="showEditStationView(scope.row)">编辑</el-button>
								<el-button @click="deleteChargeStation(scope.row)" type="danger">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div style="display: flex; justify-content: flex-end">
						<el-pagination background @current-change="currentChange" @size-change="sizeChange"
							layout="sizes, prev, pager, next, jumper, ->, total, slot" :total="total"></el-pagination>
					</div>
				</div>
				<!-- 表格 END -->
			</el-col>
		</el-row>


        </el-drawer>
		<el-dialog :title="title" :visible.sync="dialogVisible" width="1200px">
			<div style="width: 1100px">
				<el-form :model="form" :rules="formRules" ref="formRef" label-position="right" label-width="150px"
					size="600px">
					<el-row>
						<el-col :span="12"><el-form-item label="小区/站点名称:" prop="stationName">
								<el-input size="mini" style="width: 100%" prefix-icon="el-icon-edit"
									v-model="form.stationName" placeholder="请输入物业名车给"></el-input>
							</el-form-item></el-col>
						<el-col :span="12">
							<el-form-item label="物业公司:" prop="management">
								<el-input size="mini" style="width: 100%" prefix-icon="el-icon-edit"
									v-model="form.management" placeholder="请输入物业名称"></el-input>
							</el-form-item>
						</el-col>

					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="同步门禁:" prop="management">
								<el-select v-model="form.syncDoorCtrl" style="width:100%">
									<el-option v-for="item in syncDoorCtrlList" :key="item.id" :value="item.id"
										:label="item.label"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="联系人:" prop="linkman">
								<el-input size="mini" style="width: 100%" prefix-icon="el-icon-edit"
									v-model="form.linkman" placeholder="请输入联系人"></el-input> </el-form-item></el-col>
						<el-col :span="12">
							<el-form-item label="联系电话:" prop="phone">
								<el-input size="mini" style="width: 100%" prefix-icon="el-icon-edit"
									v-model="form.phone" placeholder="请输入联系电话"></el-input> </el-form-item></el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-form-item label="选择区域" prop="area">
								<v-distpicker :province="form.province" :city="form.city" :area="form.areaCode"
									@select="onSelectArea()" @province="selectProvince" @city="selectCity"
									@area="selectArea"></v-distpicker>
							</el-form-item>
						</el-col>
					</el-row>
          <el-row>
            <el-col :span="24"><el-form-item label="所属街道:" prop="street">
              <el-input size="mini" style="width: 100%" prefix-icon="el-icon-edit"
                        v-model="form.street" placeholder="请填写详细信息，如 上海市浦东新区XX路XX号" @blur="inputStreetOnBlur"></el-input>
            </el-form-item></el-col>
            <el-col :span="4">&nbsp;</el-col>
            <div class="el-col el-col-20" style="margin-top:-15px"><span
                style="line-height: 30px;">请填写详细信息，如 上海市浦东新区XX路XX号</span></div>
          </el-row>
					<el-row>
						<el-col :span="24"><el-form-item label="地址:" prop="address">
								<el-input size="mini" style="width: 100%" prefix-icon="el-icon-edit"
									v-model="form.address" placeholder="请填写详细信息，如 上海市浦东新区XX路XX号" @blur="inputAddressOnBlur"></el-input>
							</el-form-item></el-col>
						<el-col :span="4">&nbsp;</el-col>
						<div class="el-col el-col-20" style="margin-top:-15px"><span
								style="line-height: 30px;">请填写详细信息，如 上海市浦东新区XX路XX号</span></div>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="经度:" prop="stationLng" style="display: block">
								<el-input size="mini" style="width: 100%" prefix-icon="el-icon-edit"
									v-model="form.stationLng" placeholder="请输入经度"></el-input> </el-form-item></el-col>
						<el-col :span="12">
							<el-form-item label="纬度:" prop="stationLat" style="display: block">
								<el-input size="mini" style="width: 100%" prefix-icon="el-icon-edit"
									v-model="form.stationLat" placeholder="请输入纬度"></el-input> </el-form-item></el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="计费模板:" prop="feeType1">
								<el-select v-model="form.privacyId" placeholder="请选择" style="width: 100%">
									<el-option v-for="item in privacyIdOptions" :key="item.value" :label="item.label"
										:value="item.value" @change="privacySelectChange"></el-option>
								</el-select> </el-form-item></el-col>
						<el-col :span="12">
							<el-form-item label="月卡充值模板:" prop="feeType2">
								<el-select v-model="form.cardPrivacyId" placeholder="请选择" style="width: 100%">
									<el-option v-for="item in cardPrivacyIdOptions" :key="item.value"
										:label="item.label" :value="item.value"
										@change="cardPrivacySelectChange"></el-option>
								</el-select> </el-form-item></el-col>
					</el-row>

					<el-row>get
						<el-col :span="24">
							<el-form-item label="备注:" prop="remark">
								<el-input type="textarea" v-model="form.remark"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12"></el-col>
					</el-row>
				</el-form>
			</div>
			<span slot="footer" class="footer">
				<el-button type="primary" @click="doUpdate">保存设置</el-button>
			</span>
		</el-dialog>

		<!-- DIALOG ADD GATEWAY -->
		<el-dialog :title="title" :visible.sync="dialogPileNetVisible" width="1200px">
			<div style="width: 1200px">
				<el-form :model="formGateway" :rules="formGatewayRules" ref="formGatewayRef" label-position="right"
					label-width="150px" size="600px">
					<el-form-item label="所属站点:" prop="stationId">
						<el-select style="width: 85%" v-model="formGateway.stationId" placeholder="请选择"
							@change="stationIdChange">
							<el-option v-for="item in stationIdOptions" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="网关名称:" prop="gatewayName">
						<el-input size="mini" style="width: 85%" prefix-icon="el-icon-edit"
							v-model="formGateway.gatewayName" placeholder="请输入网关名称"></el-input>
					</el-form-item>
					<el-form-item label="网关编码:" prop="gatewayCode">
						<el-input size="mini" style="width: 85%" prefix-icon="el-icon-edit"
							v-model="formGateway.gatewayCode" placeholder="请输入网关编码"></el-input>
					</el-form-item>

					<el-form-item label="网关类型:">
						<el-select v-model="formGateway.type" placeholder="请选择">
							<el-option v-for="item in gatewayTypeOptions" :key="item.value" :label="item.label"
								:value="item.value" :change="gatewayTypeChange"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="备注:" prop="remark">
						<el-input type="textarea" style="width: 85%" v-model="formGateway.remark"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="footer">
				<el-button type="primary" @click="doUpdateGateway">保存设置</el-button>
			</span>
		</el-dialog>
		<!-- DIALOG ADD GATEWAY END-->
	</div>
</template>

<script>
	import {
		Message
	} from "element-ui";
	import GatewayTable from "./GatewayTable";
	import EquipmentTable from "./EquipmentTable";
	import VDistpicker from 'v-distpicker'
	import {
		putRequest,
		apiListStations,
		apiUpdate,
		apiGet,
		apiDelete,
		apiTree,
		apiCount,
		apiUpdateGateway,
		apiListPrivacy,
		apiListCardPrivacy,
		apiGetPrivacy,
		apiGetCardPrivacy,
		apiListEquipmentByStationId,
		apiGetArea,
	} from "./ChargeStation";
	import {
		apiListGatewayByStationId
	} from "./charge-equipment";
	import {apiGeocode} from "../../utils/api.js"
	export default {
		name: "ChargeStation",
		components: {
			GatewayTable,
			EquipmentTable,
			VDistpicker
		},
		data() {
			return {
				drawer:false,
				activeDetailTab: "detailTab",
				title: "", //模态窗口 标题
				searcheForm: {}, //搜索
				areaOptions:[],
				treeData: [{
					treeId: 0,
					treeName: "Root"
				}], //列表数据
				stationList: [],
				syncDoorCtrlList: [{
					id: 0,
					label: "不同步"
				}, {
					id: 1,
					label: "同步门禁"
				}],
				loading: false,
				rootStationId: "XXXXXXXXXXXXXXXXXXXXXXX",
				detailData: {
					row: {
						chargePricePrivacyInfo: {
							name: "X",
							code: "",
							feeType: "",
							prive: "",
							remark: "",
						},
						vipCardPrivacyInfo: {
							name: "X",
							code: "",
							feeType: "",
							prive: "",
							remark: "",
							availableHours: 0,
							dailyAvailableHours: 0,
						},
					},
					gatewayList: [],
					feePrivacy: {},
					cardPrivacy: {},
					equipmentList: [],
				},
				dialogVisible: false, // 是否显示 模态窗口
				dialogPileNetVisible: false,
				cardPrivacyIdOptions: [],
				privacyIdOptions: [],
				total: 0,
				page: 1,
				size: 10,
				form: {
					feeType: 1,
					discountRate: 100,
					maxFreeMinutes: 0
				},
				feeTypeOptions: [{
						label: "按小时",
						value: 1
					},
					{
						label: "按电量",
						value: 2
					},
				],
				durationOptions: [{
						label: "1小时",
						value: 1
					},
					{
						label: "2小时",
						value: 2
					},
					{
						label: "3小时",
						value: 3
					},
					{
						label: "4小时",
						value: 4
					},
					{
						label: "5小时",
						value: 5
					},
					{
						label: "6小时",
						value: 6
					},
					{
						label: "7小时",
						value: 7
					},
					{
						label: "8小时",
						value: 8
					},
				],
				formRules: {
					name: [{
							required: true,
							message: "请输入模板名称",
							trigger: "blur"
						},
						{
							min: 2,
							max: 50,
							message: "长度在 2 到 50 个字符",
							trigger: "blur",
						},
					],
					name: [{
							required: true,
							message: "请输入模板编码",
							trigger: "blur"
						},
						{
							min: 2,
							max: 50,
							message: "长度在 2 到 50 个字符",
							trigger: "blur",
						},
					],
					durationOption: [{
						required: true,
						message: "请输入充电时长配置",
						trigger: "blur"
					}, ],
					price: [{
							required: true,
							message: "请输入充个价格信息",
							trigger: "blur"
						},
						{
							min: 1,
							max: 4,
							message: "单位为分 如  10 分/小时",
							trigger: "blur",
						},
					],
					address: [{
							required: true,
							message: "请输入详细地址信息",
							trigger: "blur"
						},
						{
							min: 2,
							max: 100,
							message: "长度在 2 到 100 个字符",
							trigger: "blur",
						},
					],
					remark: [{
						required: false,
						message: "请填写备注",
						trigger: "blur"
					}],
					stationLng: [{
						required: true,
						message: "经度整数部分为0-180,小数部分为0到6位!",
						trigger: "blur",
					}, ],
					stationLat: [{
						required: true,
						message: "纬度整数部分为0-90,小数部分为0到6位!",
						trigger: "blur",
					}, ],
				},
				// Gateway Config Prop
				formGateway: {
					gatewayType: 3,
					remoteSiteId: "",
					gatewayName: '',
				},
				gatewayTypeOptions: [{
						label: "W1",
						value: 3
					},
					{
						label: "ZY",
						value: 5
					},
				],
				stationIdOptions: [],
				formGatewayRules: {
					gatewayName: [{
						required: true,
						message: "请输入网关名称",
						trigger: "blur"
					}, ],
					gatewayCode: [{
						required: true,
						message: "请输入网关编码",
						trigger: "blur"
					}, ],
					remark: [{
						required: false,
						message: "请填写备注",
						trigger: "blur"
					}],
				},
				// Gateway Config Prop End
			};
		},
		created() {
			this.feeType = 1;
			this.list();
			this.listArea()
		},
		mounted() {},
		methods: {
			stationTableItemClick(row){
				this.drawer=true
				Message.success({
					message: "当前站点："+row.stationName
				});
				const _detailId = row.id;
				this.detailData.row.id = _detailId;
				this.rootStationId = _detailId;
				this.loadStationDetailById(_detailId);
				if (this.activeDetailTab == "detailGatewayTab") {
					this.$refs.GatewayTable.$emit("listGateway", {
						id: _detailId
					});
				}
				if (this.activeDetailTab == "detailEquipmentTab") {
					this.$refs.EquipmentTable.$emit("listEquipments", {
						stationId: _detailId,
					});
				}
			},
			inputAddressOnBlur(){
				const _address = this.form.province+this.form.city+this.form.area+this.form.address;
				apiGeocode(_address).then(resp=>{
					const location = resp;
					const locs = location.split(',')
					this.form.stationLng = locs[0]
					this.form.stationLat = locs[1]
				})
			},
      inputStreetOnBlur(){
        const _street = this.form.street;
      },
			search() {

				this.list();
			},
			handleChange(value) {
			        console.log(value);
			},
			listArea(){
				apiGetArea().then(resp=>{
					console.dir(resp)
					this.areaOptions = resp.data
				})
			},
			onSelectArea(data) {
				// console.log(data)
			},
			selectProvince({
				code,
				value
			}) {
				this.form.province = value
				this.form.provinceCode = code
			},
			selectCity({
				code,
				value
			}) {
				this.form.city = value
				this.form.cityCode = code
			},
			selectArea({
				code,
				value
			}) {
				this.form.area = value
				this.form.areaCode = code
				
			},
			loadStationDetailById(id) {
				if (id == undefined) {
					return;
				}
				apiGet(id).then((resp) => {
					if (resp.status == 200) {
						this.form = resp.data;
						this.detailData.row = resp.data;
					}
				});
			},
			loadStationgatewayById(id) {
				// apiListGatewayByStationId({ stationId: id }).then((resp) => {
				//   if (resp.status == 200) {
				//     this.detailData.gatewayList = resp.data.list;
				//   }
				// });
				this.$refs.GatewayTable.$emit("listGateway", {
					id: this.detailData.row.id
				});
			},
			loadStationEquipmentById(id) {
				// apiListEquipmentByStationId({ stationId: id }).then((resp) => {
				//   if (resp.status == 200) {
				//     this.detailData.equipmentList = resp.data.list;
				//   }
				// });
				this.$refs.EquipmentTable.$emit("listEquipments", {
					stationId: id
				});
			},
			loadStationPrivacyById() {
				apiGetPrivacy(this.detailData.row.privacyId).then((resp) => {
					if (resp.status == 200) {
						this.detailData.feePrivacy = resp.data;
					}
				});
			},
			loadStationCardPrivacyById() {
				// console.log(JSON.stringify(this.detailData.row));
				apiGetCardPrivacy(this.detailData.row.cardPrivacyId).then((resp) => {
					if (resp.status == 200) {
						this.detailData.cardPrivacy = resp.data;
					}
				});
			},
			tabClick(tab) {
				if (!this.detailData.row.id) {
					Message.error({
						message: "请从左侧树中选择一个站点"
					});
					return;
				}
				const tabName = tab.name;
				const id = this.detailData.row.id;
				if (tabName == "detailTab") {
					this.loadStationDetailById();
				} else if (tabName == "detailGatewayTab") {
					this.loadStationgatewayById(id);
				} else if (tabName == "detailEquipmentTab") {
					this.loadStationEquipmentById(id);
				} else if (tabName == "detailFeeTab") {
					// this.loadStationPrivacyById(this.detailData.row.privacyId);
				} else if (tabName == "detailCardFeeTab") {
					// this.loadStationCardPrivacyById(this.detailData.row.cardPrivacyId);
				}
			},
			showAdd() {
				this.loadFeeTemplates();
				this.title = "添加站点";
				this.form = {};
				this.dialogVisible = true;
			},
			//编辑站点信息
			showEditStationView(data) {
				this.loadFeeTemplates();
				this.title = "编辑";
				this.form = data;
				this.dialogVisible = true;
			},
			deleteChargeStation(row) {},
			// 页大小
			sizeChange(currentSize) {
				this.size = currentSize;
				this.list();
			},
			// 选择页
			currentChange(currentPage) {
				this.page = currentPage;
				this.list("advanced");
			},
			handleChange(v) {
				this.$refs.form.discountRate = v;
			},
			checkLong(lng) {
				var longrg =
					/^(\-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,6})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,6}|180)$/;
				if (!longrg.test(lng)) {
					Message.error({
						message: "经度整数部分为0-180,小数部分为0到6位!"
					});
					return false;
				}
				return true;
			},
			checkLat(lat) {
				var latreg = /^(\-|\+)?([0-8]?\d{1}\.\d{0,6}|90\.0{0,6}|[0-8]?\d{1}|90)$/;
				if (!latreg.test(lat)) {
					Message.error({
						message: "纬度整数部分为0-90,小数部分为0到6位!"
					});
					return false;
				}
				return true;
			},
			handleChangeFreeFee(v) {
				this.$refs.form.maxFreeMinutes = v;
			},
			list() {
				this.searcheForm.page = this.page;
				this.searcheForm.size = this.size;
				
				if(this.searcheForm.area!=undefined){
					console.log('size'+this.searcheForm.area.length)
					this.searcheForm.level = this.searcheForm.area.length-1;
					this.searcheForm.areaCode = this.searcheForm.area[this.searcheForm.area.length-1]
				}
				console.log(this.searcheForm.areaCode)
				apiListStations(this.searcheForm).then((resp) => {
				  if (resp.status == 200) {
				    const data = resp.data;
				    this.stationList = data.list;
				    // this.detailData=this.stationList[0];
				    this.total = data.total;
				    this.page = data.pageNum;
				    this.size = data.pageSize;
				  }
				});

				// apiTree(this.searcheForm).then((resp) => {
				// 	if (resp.status == 200) {
				// 		const data = resp.data;
				// 		this.treeData = data;
				// 	}
				// });
			},
			doUpdate() {
				let url = "/api/chargeStation/update";
				const valid = this.$refs["formRef"].validate((valid) => {
					if (!valid) {
						return;
					}
					if (!this.checkLong(this.form.stationLng)) {
						return;
					}
					if (!this.checkLat(this.form.stationLat)) {
						return;
					}
					// checkDurationOption();
					apiUpdate(this.form).then((resp) => {
						Message.success({
							message: resp.msg
						});
						if (resp.status == 200) {this.dialogVisible = false;}
					});
				});
			},
			doUpdateGateway() {
				const valid = this.$refs["formGatewayRef"].validate((valid) => {
					if (!valid) {
						return;
					}
					// checkDurationOption();
					apiUpdateGateway(this.formGateway).then((resp) => {
						let type = "更新";
						if (
							this.form.id == undefined ||
							this.form.id == null ||
							this.form.id == 0
						) {
							type = "添加";
						}
						if (resp.status == 200) {
							Message.success({
								message: type + "成功"
							});
							this.dialogVisible = false;
							this.list();
						}
					});
				});
			},
			checkDurationOption() {
				let durationOption = this.form.durationOption;
				if (durationOption == null || durationOption.length == 0) {
					Message.error({
						message: "请设置有效的充电时段!"
					});
				}
				let index = durationOption.indexOf(",");
				let regex = /^\d+$/;
				if (index == -1) {
					if (!regex.test(durationOption)) {
						Message.error({
							message: "请设置有效的充电时段,只能输入数字，多时段通过,分割!",
						});
						return false;
					}
				}
				let texts = durationOption.split(",");
				for (let i = 0; i < texts.length; i++) {
					if (!regex.test(texts[i])) {
						Message.error({
							message: "请设置有效的充电时段," + texts[i] + "不是有效的参数",
						});
						return false;
					}
				}
				return true;
			},
			loadNode(node, resolve) {
				if (node.level === 0) {}
				if (node.level > 1) return resolve([]);

				setTimeout(() => {
					const data = [{
							stationName: "leaf",
							leaf: true,
						},
						{
							stationName: "zone",
						},
					];

					resolve(data);
				}, 500);
			},
			nodeClick(data) {
				//data.children.push({treeId:new Date().getTime(),treeName:'插座网关'});
				console.log("You CLicked = " + JSON.stringify(data));


				let isLeaf = data.leaf;
				if (!isLeaf) {
					this.detailData.row.id = data.treeId;
					this.rootStationId = data.treeId;
					this.loadStationDetailById(data.treeId);
					if (this.activeDetailTab == "detailGatewayTab") {
						this.$refs.GatewayTable.$emit("listGateway", {
							id: data.treeId
						});
					}
					if (this.activeDetailTab == "detailEquipmentTab") {
						this.$refs.EquipmentTable.$emit("listEquipments", {
							stationId: data.treeId,
						});
					}
				}
			},
			searchEquipment() {
				const formData = {
					stationId: this.detailData.row.id
				};
				if (formData.stationId == undefined) {
					Message.error({
						message: '从左侧树中选择一条记录'
					});
					return;
				}
				this.$refs.EquipmentTable.$emit("listEquipments", formData);
			},
			// Loading Fee Template
			loadFeeTemplates() {
				if (this.privacyIdOptions.length > 0) {
					return 0;
				}
				let form = {
					page: 1,
					size: 9999
				};
				apiListCardPrivacy(form).then((resp) => {
					if (resp.status == 200) {
						resp.data.list.forEach((element) => {
							this.cardPrivacyIdOptions.push({
								label: element.name,
								value: element.id,
							});
						});
						// this.form.cardPrivacyId = this.cardPrivacyIdOptions[0].value;
					}
				});

				apiListPrivacy(form).then((resp) => {
					if (resp.status == 200) {
						resp.data.list.forEach((element) => {
							this.privacyIdOptions.push({
								label: element.name,
								value: element.id,
							});
						});
						// this.form.privacyId = this.privacyIdOptions[0].value;
					}
				});
			},

			//
			cardPrivacySelectChange(v) {},
			privacySelectChange(v) {},
			/**
			 * Gateawy Methods
			 **/
			appendGateway(data) {
				// Data.id

				// Data.RemoteId
				this.dialogPileNetVisible = true;
				if (this.stationIdOptions.length == 0) {
					this.initDictionaryStation(data);
				}
				this.formGateway.stationId = data.treeId;
				this.formGateway.remoteSiteId = data.remoteId;
				this.formGateway.title = "添加组网网关";
				this.stationIdChange(data.treeId);
			},
			tableClickedAppendGateway(data) {
				this.dialogPileNetVisible = true;
				if (this.stationIdOptions.length == 0) {
					this.initDictionaryStation(data);
				}
				this.formGateway.stationId = data.id;
				this.formGateway.remoteSiteId = data.remoteSiteId;
				this.formGateway.title = "添加组网网关";
				this.stationIdChange(data.id);
			},
			initDictionaryStation(data) {
				apiListStations(this.searcheForm).then((resp) => {
					if (resp.status == 200) {
						const data = resp.data;
						this.stationList = data.list;
						this.stationList.forEach((element) => {
							this.stationIdOptions.push({
								label: element.stationName,
								value: element.id,
							});
						});
						// setTimeout(() => {
						//   this.formGateway.stationId = data.treeId;
						//   this.formGateway.remoteSiteId = data.remoteId;
						// }, 500);
					}
				});
			},
			appendPlug(data) {},
			gatewayTypeChange(row) {
				console.log(JSON.stringify(row));
			},
			stationIdChange(id) {
				this.stationList.forEach((element) => {
					if (element.value == id) {
						this.formGateway.remoteSiteId = element.remoteSiteId;
					}
				});

				apiCount(id).then((resp) => {
					if (resp.status == 200) {
						const data = resp.data;
						this.formGateway.gatewayName = "";
						this.formGateway.gatewayName = parseInt(data.count) + 1 + "";
						this.$set(this.formGateway, 'gatewayName', this.formGateway.gatewayName);
					}
				});
			},
			gatewayTypeFormatter(row, column, cellValue, index) {
				if (row.gatewayType == 3) {
					return "W1";
				}
				if (row.gatewayType == 5) {
					return "ZY";
				}
			},
			stationIdFormatter(row, column, cellValue, index) {},
			// Gateway Methods End
		},
	};
</script>

<style>
	.page-body {
		margin-top: 30px;
	}

	/* 可以设置不同的进入和离开动画 */
	/* 设置持续时间和动画函数 */
	.slide-fade-enter-active {
		transition: all 0.8s ease;
	}

	.slide-fade-leave-active {
		transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
	}

	.slide-fade-enter,
	.slide-fade-leave-to

	/* .slide-fade-leave-active for below version 2.1.8 */
		{
		transform: translateX(10px);
		opacity: 0;
	}

	.el-input--mini .el-input__inner {
		height: 48px;
		line-height: 48px;
	}

	.footer {
		padding-left: 500px;
	}

	.detail-row {
		line-height: 35px;
		padding: 5px 0px;
		font-size: 18px;
	}

	.detail-row .detail-col-odd {
		text-align: left;
	}

	.detail-row .detail-col-even {
		text-align: right;
	}

	.tree-node-checked {
		color: #409EFF;
	}
</style>